import {
  defaultAuthRedirectPath,
  defaultPostLogoutRedirectPath,
} from '@vs/oidc-client';
import type { OidcClientSettings } from 'oidc-client-ts';

import { basePath, isLocalDevMode } from '.';
import { env } from './env';

export const oidcConfig: OidcClientSettings = {
  post_logout_redirect_uri: `${window.location.origin}${basePath}${defaultPostLogoutRedirectPath}`,
  redirect_uri: `${window.location.origin}${basePath}${defaultAuthRedirectPath}`,
  response_type: 'code',
  scope: 'openid profile email',
  client_id: 'b78ecdf9-b9fd-4027-b4f0-2bd8b292e6ed',
  authority: isLocalDevMode
    ? env.oidcAuthority.vs
    : `${window.location.origin}/auth/v1/oidc`,
};
